import { Text } from '@billda/design-system';
import { formatCurrency } from '../../../shared/utils/currency';

interface PaymentLineItemRowProps {
  name: string;
  amount: number;
  subtitle?: string;
}

export function PaymentLineItemRow({
  name,
  amount,
  subtitle,
}: PaymentLineItemRowProps) {
  return (
    <div className="flex items-center justify-between">
      <Text variant="body2">
        {name}
        {subtitle && (
          <Text as="span" variant="caption" color="secondary" className="ml-2">
            ({subtitle})
          </Text>
        )}
      </Text>
      <Text variant="body1" className="font-medium text-content-success">
        {formatCurrency(amount)}
      </Text>
    </div>
  );
}
